import cx from 'classnames';
import React from 'react';

type Props = {
  title?: string;
  description?: string;
  icon: {
    src: string;
    alt: string;
    iconBg?: string;
  };
};

export const InfoCard: React.FC<Props> = ({ icon, title, description }) => (
  <div className="tw-relative tw-pt-20 md:tw-pt-40 tw-w-full tw-max-w-3xl tw-m-auto tw-py-12 tw-text-primary tw-bg-component tw-rounded-2xl tw-text-center md:tw-pt-24 md:tw-pb-14">
    <div
      className={cx(
        'tw-absolute -tw-top-6 tw-left-1/2 tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-20 tw-h-20 tw-rounded-full -tw-translate-x-1/2 md:tw-w-40 md:tw-h-40',
        icon.iconBg,
      )}
    >
      <img className="tw-w-8 md:tw-w-16" src={icon.src} alt={icon.alt} />
    </div>
    {title && <div className="tw-text-9xl tw-mb-6">{title}</div>}
    {description && (
      <div className="tw-text-2xl tw-px-8 tw-text-secondary">{description}</div>
    )}
  </div>
);
